export default function documentLinkTypesResponse(response) {
    return response.reduce((acc, type) => {
        acc[type.id] = type.name;
        return acc;
    }, {});
}